__turbopack_context__.v({
  "logoWrapper": "WixStudioBanner-module-scss-module__rlnnkG__logoWrapper",
  "studioBanner": "WixStudioBanner-module-scss-module__rlnnkG__studioBanner",
});
